import useTranslations from '@/i18n/useTranslations';
import XIcon from '@/shared-components/icons/components/public/XIcon';
import Text from '@/shared-components/text/components/Text';

export default function LimitedEditionsNotAvailable({ close }) {
  const t = useTranslations('common.forms.add_artwork');
  return (
    <>
      <div className="limited-edition-popup-content__container remove-scrollbar">
        <div className="limited-edition-popup-content__header">
          <Text className="limited-edition-popup-content__header-text">{t('limited_editions.popup.unavailable_title')}</Text>
          <XIcon className="limited-edition-popup-content__close" onClick={close}/>
        </div>

        <div className="limited-edition-popup-error__content">
          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            {t('limited_editions.popup.unavailable_intro')}
          </Text>

          {/* START OF POINTS */}
          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            <span/>{t('limited_editions.popup.requirement_inventory')}
          </Text>

          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            <span/>{t('limited_editions.popup.requirement_dimensions')}
          </Text>

          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            <span/>{t('limited_editions.popup.requirement_price')}
          </Text>

          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            <span/>{t('limited_editions.popup.requirement_format')}
          </Text>
          {/* END OF POINTS */}

          <Text
            className="limited-edition-popup-error__text font-size-small"
            paragraph
            justify>
            {t('limited_editions.popup.unavailable_outro')}
          </Text>
        </div>
      </div>
    </>
  );
}
